const FromArr = [
  {
    title: "",
    modelvalue: "",
    inputtype: "select",
    inputflag: true,
    fontSize: 14,
    color: "#424E66",
    lableheight: 20,
    types: "text",
    placeholder: "发布人",
    width: 180,
    height: 32,
    disabled: false,
    marginLeft: -262,
    marginTop: 35,
    X: false,
    options: [],
  },
  {
    title: "",
    inputtype: "dateSection",
    inputflag: true,
    fontSize: 14,
    color: "#424E66",
    lableheight: 20,
    X: false,
    types: "date",
    placeholder: "发布时间",
	widthLeft:180,
	widthRight:180,
    disabled: false,
    heightLeft: 32,
    heightRight: 32,
    marginLeft: 10,
    marginTop: 35,
    StartTime: "",
    EndTime: "",
  },
];
export default FromArr;
